export enum IbexaColorPair {
  Blue = 'blue-pair',
  GreenCoral = 'green-coral-pair',
  Violet = 'violet-pair',
  BlueCoral = 'blue-coral-pair',
  BlueViolet = 'blue-violet-pair',
  YellowBlue = 'yellow-blue-pair',
  VioletOrange = 'violet-orange-pair',
  DisabledPair = 'disabled-pair',
}

export default IbexaColorPair
